import { Link } from "react-router-dom"
import { Typography, Card, CardContent, CardMedia } from "@mui/material"
import { CheckCircle } from "@mui/icons-material"

import { demoChannelUrl, demoVideoUrl, demoChannelTitle, demoVideoTitle } from '../data/constants'

const VideoCard = ({ video: { id: { videoId }, snippet } }) => {
  return (
    <Card sx={{
    boxShadow : 'none',
    borderRadius: 0,
    width: '338px', 
    height: '300px'}}>

      <Link to={videoId ? `/video/${videoId}` : demoVideoUrl} >

        <CardMedia image={snippet?.thumbnails?.high?.url} 
          alt={snippet?.title}
          sx={{width: '338px', height: '190px'}}
        />

      </Link>

      <CardContent sx={{ backgroundColor: '#1e1e1e', height: '80px', padding: '10px'}}>

        <Link to={videoId? `/video/${videoId}` : demoVideoUrl} >
          <Typography variant="subtitle1" sx={{fontWeight:'bold' ,color: '#fff'}} >

            {snippet?.title.slice(0,60) || demoVideoTitle.slice(0,60)}
            
          </Typography>
        </Link>

        <Link to={snippet?.channelId ? `/channel/${snippet?.channelId}` : demoChannelUrl} >
          <Typography variant="subtitle2" fontWeight='bold' color= 'gray' >

            {snippet?.channelTitle || demoChannelTitle}
            <CheckCircle sx={{fontSize: 12, color: 'gray', ml: '5px'}} />

          </Typography>
        </Link>
      </CardContent>
      
    </Card>
  )
}

export default VideoCard